/**
 * First field error out of the API's `{ errors: { field: string[] } }`
 * validation shape (the multipart create endpoints return it with non-2xx).
 * Extracted from the QC create mutation in UG-4505 — shared by the QC and
 * AWA response submits, whose multipart bodies bypass the typed RPC client.
 */
export const firstFieldError = (body: unknown): string | null => {
  if (!body || typeof body !== 'object') return null;
  const errors = (body as { errors?: unknown }).errors;
  if (!errors || typeof errors !== 'object') return null;
  for (const value of Object.values(errors as Record<string, unknown>)) {
    if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') return value[0];
  }
  return null;
};
